import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import _ from 'lodash';
import type { useGetRiskListOptimized } from 'src/hooks/queries/risk/useGetRiskListOptimized';

import { getFriendlyId } from '@/utils/friendlyId';

type GetRiskListOptimizedData = NonNullable<
  ReturnType<typeof useGetRiskListOptimized>['data']
>;

export const getOptions = (
  data: GetRiskListOptimizedData | undefined,
  selectedRiskId: string | undefined
) => {
  const risksById = _.keyBy(data?.risk, 'Id');
  let options: {
    Id: string;
    Title?: string;
    SequentialId?: null | number | undefined;
  }[] = data?.risk ?? [];

  options = options.concat(
    (data?.node ?? []).filter(
      (n) => !risksById[n.Id] && n.Id === selectedRiskId
    )
  );

  return (
    options.map((r) => ({
      value: r.Id,
      label: r.Title ?? getFriendlyId(Parent_Type_Enum.Risk, r.SequentialId),
    })) ?? []
  );
};
